import type { TrackingProps } from './types';

type DataLayerSettings = {
  environment: 'dev' | 'live';
  anonymizeIP: boolean;
  isBot: boolean;
  locale: string;
  language: string;
  market: string;
};

const hasSearchParam = (param: string) =>
  typeof window !== 'undefined'
    ? Boolean(new URLSearchParams(window.location.search).get(param))
    : false;

const baseConfig: Omit<
  TrackingProps,
  | 'virtPath'
  | 'landingpageKategorie'
  | 'websitebereich'
  | 'englishPageName'
  | 'landingPageType'
> = {
  environment: 'live',
  affiliateName: 'bm',
  SPA: false,
  nextjs: true,
  twa: hasSearchParam('twa'),
  hasTduid: hasSearchParam('tduid'),
  blockUserCentrics: true,
  anonymizeIP: true,
  // Overwritten from the site settings on every page view; `false` only stands
  // in for the window before they arrive, which no tracking call reaches.
  isBot: false,
  locale: '',
  language: '',
  market: '',
};

export { baseConfig };
export type { DataLayerSettings };
